import PortalLayout, { PortalLayoutProps } from './PortalLayout';

export type { PortalLayoutProps };
export default PortalLayout;
